const cleanPhoneNumber = (number = "") => {
  return number.replace(/[^0-9]/, "");
};

export default cleanPhoneNumber;
